<button><ng-content/></button>